module.exports = __webpack_public_path__ + "static/media/+2 MPC(20-06-2026).8638537e.xlsx";